import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { allPages, periodAccessPages } from "../components/ProgressNav";
import { getGroupData, getSelectedPeriod } from "../services/GroupContext";
import toast from "./DismissibleToast";

// Redirects users to the home screen if they don't have access to the cached group;
export const GroupAccessRoute = ({ children }) => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname.toLowerCase();

  const furthestVisitedPage =
    getGroupData()?.["furthest_page_visited"] || "/app/useraccess";
  const furthestVisitedIndex = allPages.findIndex(
    (p) => p === furthestVisitedPage,
  );
  const currentPageIndex = allPages.findIndex((p) => p === currentPath);
  const userIsPastFurthestVisitedPage = currentPageIndex > furthestVisitedIndex;
  const selectedPeriod = getSelectedPeriod();
  const isPeriodAccessPage = periodAccessPages.includes(currentPath);

  useEffect(() => {
    if (isPeriodAccessPage && !selectedPeriod) {
      toast("Please select a Group PoA before accessing this page.", {
        icon: "⚠️",
      });
      navigate("/app/grouppoa");
      return;
    }

    if (userIsPastFurthestVisitedPage) {
      toast(
        `You cant access ${window.location.pathname} without visiting all previous pages.`,
        { icon: "⚠️" },
      );
      navigate(furthestVisitedPage);
    }
  }, [
    furthestVisitedPage,
    isPeriodAccessPage,
    navigate,
    selectedPeriod,
    userIsPastFurthestVisitedPage,
  ]);

  if (
    !userIsPastFurthestVisitedPage &&
    (!isPeriodAccessPage || selectedPeriod)
  ) {
    return children;
  }
};
